import type { IconData } from '@stacksjs/iconify-core'

export const shoppingBagAlt: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 8v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8zm0-2V3a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v3h2v11a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6zm2 0h6V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingBagAlt
